import { useMutation } from '@tanstack/react-query'
import { OptionalMutationOptions } from 'src/queries/agent/domain/queries.utils'
import {
  PostAgentPromptRequest,
  PostAgentPromptResponse,
} from 'src/queries/agent/network/agent.models'
import { postInsightsPrompt } from 'src/queries/agent/network/insights.network'
import { agentQueryKeys } from 'src/queries/queries.constants'

export const usePostInsightsPrompt = (
  options?: OptionalMutationOptions<
    PostAgentPromptResponse,
    PostAgentPromptRequest
  >,
) => {
  return useMutation({
    mutationFn: (data) => postInsightsPrompt(data),
    mutationKey: agentQueryKeys.insights(),
    ...options,
  })
}
